'use client';
import { Stack } from '@mui/material';
import { NavLinkType, SettingsProps } from '../types';
import Optional from '../../../Optional';
import RichCtaButton from '../../../elements/RichCtaButton';
import NavDropdown from '../common/NavDropdown';

type Props = SettingsProps & { linksOverride?: NavLinkType[]; hideCta?: boolean };

const DesktopMenu = ({ navigation, linksOverride, hideCta }: Props) => {
  const { cta, links } = navigation;
  const displayLinks = linksOverride ?? links;
  return (
    <Stack direction="row" spacing={2} component={'nav'}>
      {displayLinks?.map((link) => (
        <NavDropdown key={link.label} link={link} />
      ))}
      <Optional condition={!!cta && !hideCta}>
        <RichCtaButton track={{ position: 'nav' }} cta={cta} />
      </Optional>
    </Stack>
  );
};

export default DesktopMenu;
